export default __webpack_public_path__ + "static/media/00.c93e9009.jpg";